import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Slider from 'react-slick';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ProjectModal from '../components/ProjectModal'; // Importar el nuevo componente
import GradientSeparator from '../components/GradientSeparator';

import logoObreasCiviles from '../public/Servicios/LogoEmpresa.png';
import logoHabilitaciones from '../public/Servicios/LogoEmpresa.png';
import logoEducacion from '../public/Servicios/LogoEmpresa.png';
import logoElectrico from '../public/Servicios/LogoEmpresa.png';
import logoProyectos from '../public/Servicios/LogoEmpresa.png';


const services = [
  {
    title: 'Obras Civiles',
    description: 'Construcción de infraestructuras, montaje de estructuras y techumbres, pavimentación, redes sanitarias, y más.',
    icon: logoObreasCiviles,
  },
  {
    title: 'Habilitaciones',
    description: 'Desarrollo de proyectos para locales comerciales, incluyendo obras sanitarias, climatización, incendios y terminaciones.',
    icon: logoHabilitaciones,
  },
  {
    title: 'Recintos Educacionales',
    description: 'Construcción y remodelación de escuelas, universidades y centros de formación, creando ambientes óptimos para el aprendizaje.',
    icon: logoEducacion,
  },
  {
    title: 'Proyectos Eléctricos',
    description: 'Diseño e implementación de sistemas eléctricos de baja y media tensión para diversos tipos de edificaciones e industrias.',
    icon: logoElectrico,
  },
  
  {
    title: 'Desarrollo de proyectos',
    description: 'Gestionamos y diseñamos tu proyecto de construcción.',
    icon: logoProyectos,
  }
];

const projectModules = require.context('../public/Proyectos', true, /\.json$/);
const imageModules = require.context('../public/Proyectos', true, /\.(png|jpe?g|svg)$/i);

const projects = projectModules.keys().map(key => {
  const projectData = projectModules(key);
  const projectDir = key.substring(0, key.lastIndexOf('/')); // e.g., './1. HABILITACIONES'

  const imagePaths = projectData.images.map(imageName => {
    const imagePathKey = `${projectDir}/${imageName}`;
    try {
      return imageModules(imagePathKey);
    } catch (e) {
      console.error(`Image not found: ${imagePathKey}`);
      return null;
    }
  }).filter(Boolean); // Filtra las imágenes que no se encontraron

  return {
    ...projectData,
    image: imagePaths[0] || null, // Usa la primera imagen o null si no hay ninguna
    images: imagePaths,
  };
});

const Servicios = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
  };

  const handleCloseModal = () => {
    setSelectedProject(null);
  };

  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} custom-arrow next-arrow`}
        style={{ ...style, display: 'block', right: '-25px' }}
        onClick={onClick}
      >
        <ChevronRight size={30} />
      </div>
    );
  };

  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} custom-arrow prev-arrow`}
        style={{ ...style, display: 'block', left: '-25px' }}
        onClick={onClick}
      >
        <ChevronLeft size={30} />
      </div>
    );
  };

  const sliderSettings = {
    dots: true,
    infinite: projects.length > 4,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const serviceSliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div>
      {/* Sección de Servicios */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <motion.h2
            className="text-4xl font-bold text-center text-gray-800 mb-12"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.6 }}
          >
            Nuestros Servicios
          </motion.h2>
          <div className="px-4">
            <Slider {...serviceSliderSettings}>
              {services.map((service, index) => (
                <div key={index} className="px-2 py-4">
                  <motion.div
                    className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-300 flex flex-col min-h-[360px]"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                  >
                    <div>  
                      { /*service.icon */}
                      <img src="" alt={service.title} className="w-24 h-24 mx-auto mb-6" />
                      <h3 className="text-2xl font-semibold text-gray-800 mb-4">{service.title}</h3>
                    </div>
                    <p className="text-gray-600">{service.description}</p>
                  </motion.div>
                </div>
              ))}
            </Slider>
            </div>
        </div>
      </section>

      <GradientSeparator />

      {/* Sección de Proyectos */}
      <section id="proyectos" className="py-16 bg-white">
        <div className="container mx-auto px-6">
            <motion.h2
              className="text-4xl font-bold text-center text-gray-800 mb-12"
              initial={{ opacity: 0, y: -20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.6 }}
            >
              Nuestros Proyectos
            </motion.h2>
            {projects.length > 4 ? (
              <Slider {...sliderSettings}>
                {projects.map((project, index) => (
                  <div key={project.id} className="px-4">
                    <motion.div
                      className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 cursor-pointer h-full"
                      initial={{ opacity: 0, scale: 0.9 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={{ once: true, amount: 0.3 }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                      onClick={() => handleProjectClick(project)}
                    >
                      <img src={project.image} alt={project.name} className="w-full h-64 object-cover" />
                      <div className="p-6">
                        <h3 className="text-1xl font-semibold text-gray-800 mb-2">{project.name}</h3>
                      </div>
                    </motion.div>
                  </div>
                ))}
              </Slider>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {projects.map((project, index) => (
                  <motion.div
                    key={project.id}
                    className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 cursor-pointer"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    onClick={() => handleProjectClick(project)}
                  >
                    <img src={project.image} alt={project.name} className="w-full h-64 object-cover" />
                    <div className="p-6">
                      <h3 className="text-2xl font-semibold text-gray-800 mb-2">{project.name}</h3>
                    </div>
                  </motion.div>
                ))}
              </div>
            )}
          </div>
      </section>

      <GradientSeparator />

      {/* Formulario de Contacto */}
      <section id="contacto" className="py-16 bg-gray-50">
        <div className="container mx-auto px-6 max-w-2xl">
          <motion.h2
            className="text-4xl font-bold text-center text-gray-800 mb-12"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.6 }}
          >
            Contáctanos
          </motion.h2>
          <motion.form
            className="bg-footer-bg rounded-lg shadow-lg p-8 space-y-6"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            <div>
              <label htmlFor="name" className="block text-white text-sm font-bold mb-2">
                Nombre Completo
              </label>
              <input
                type="text"
                id="name"
                className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Tu nombre"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-white text-sm font-bold mb-2">
                Correo Electrónico
              </label>
              <input
                type="email"
                id="email"
                className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="tu@ejemplo.com"
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-white text-sm font-bold mb-2">
                Mensaje
              </label>
              <textarea
                id="message"
                rows="6"
                className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Escribe tu mensaje aquí..."
              ></textarea>
            </div>
            <motion.button
              type="submit"
              className="bg-caterpillar-yellow hover:bg-caterpillar-yellow-dark text-black font-bold py-3 px-6 rounded-lg focus:outline-none focus:shadow-outline transition duration-300 w-full"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Enviar Mensaje
            </motion.button>
          </motion.form>
        </div>
      </section>

      <ProjectModal project={selectedProject} onClose={handleCloseModal} />
    </div>
  );
};

export default Servicios;